<template>
  <div class="carousel-item">
    <el-tag class="tag">{{ value.images.length }}张</el-tag>
    <em class="el-icon-success"></em>
    <div class="images-wrapper">
      <div class="image">
        <img :class="value.images[0].height > value.images[0].width ? 'vertical' : 'horizontal'" :src="value.images[0].url" alt="" />

        <!--  <img
          v-for="img in value.images"
          :key="img.image_id"
          :class="img.height > img.width ? 'vertical' : 'horizontal'"
          :src="img.url"
          alt=""
        /> -->
      </div>
    </div>

    <div class="file-name">
      <span>{{ value.file_name }} </span>
      <slot name="changebtn"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.carousel-item {
  border: 2px solid transparent;
  position: relative;
  &.active {
    border: 2px solid #1890ff;
    .el-icon-success {
      display: block;
    }
  }

  .el-icon-success {
    display: none;
    color: #1890ff;
    font-size: 20px;
    position: absolute;
    right: 0;
    top: 4px;
    z-index: 2;
  }

  .tag {
    position: absolute;
    left: 10px;
    top: 10px;
    opacity: 0.9;
    z-index: 2;
  }

  .file-name {
    text-align: center;
    line-height: 32px;
  }
  .images-wrapper {
    padding: 6px 0;
    background: #f3f3f3;

    .image {
      width: 140px;
      height: 249px;
      text-align: center;
      position: relative;

      img {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }

      .horizontal {
        width: 100%;
      }
      .vertical {
        height: 100%;
      }
    }
  }
}
</style>
